export default "__VITE_ASSET__BWSFDYFr__"